import {createSlice} from "@reduxjs/toolkit";
import {
  DataGridPageState,
  DEFAULT_DISPATCH_REQUEST_FILTER,
  DispatchRequestFilterFormValues
} from "@ots-frontend/ots-ui";
import {setDispatchRequestPageFilter, setDispatchRequestPageState, setDispatchRequestPageStateSort} from "./actions";
import {setDispatchRequestPageStateCell, setDispatchRequestPageStateWidths} from "../dispatch-request-page/actions";

const savedColWidths = localStorage.getItem("dispatchRequestPageWidths2")

type State = {
  filter: DispatchRequestFilterFormValues
  state: DataGridPageState
}

const INITIAL_STATE: Readonly<State> = {
  filter: DEFAULT_DISPATCH_REQUEST_FILTER,
  state: {
    cell: undefined,
    widths: savedColWidths ? JSON.parse(savedColWidths) : [],
  }
};

const dispatchRequestPageSlice = createSlice({
  name: "ui/dispatch-request-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setDispatchRequestPageFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
    builder.addCase(
      setDispatchRequestPageState,
      (state, {payload}) => {
        state.state = payload
      }
    );
    builder.addCase(
      setDispatchRequestPageStateCell,
      (state, {payload}) => {
        state.state.cell = payload
      }
    );
    builder.addCase(
      setDispatchRequestPageStateWidths,
      (state, {payload}) => {
        state.state.widths = payload
      }
    );
    builder.addCase(
      setDispatchRequestPageStateSort,
      (state, {payload}) => {
        state.state.sort = payload
      }
    );
  }
});

export const dispatchRequestPageReducer = dispatchRequestPageSlice.reducer;
